<template>
  <div class="wrapper">
    <!-- LIST VIEW -->

    <v-list-item three-line v-if="!gridView" dense :class="mediaTypeColor">
      <v-checkbox
        v-if="showCheckbox"
        v-model="isCheckedInternal"
        @change="$emit('changeChecked', $event)"
        color="primary"
        class="mr-2"
      ></v-checkbox>
      <v-list-item-avatar tile height="70px" width="80px">
        <!--        <v-img :src="media.url"></v-img>-->
        <!-- <img class="mr-4" v-auth-image="media.url" /> -->
        <v-img
          :src="mediaData"
          max-width="100px"
          contain
          class="grey darken-4 black--text align-end"
          @error="onImageError"
        />
      </v-list-item-avatar>

      <v-list-item-content class="ml-4">
        <v-list-item-title class="subtitle-1">
          <span v-if="isTitleImage" class="font-weight-bold pr-3"
            >TITLE IMAGE</span
          >
          <span v-html="descriptionText"></span>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ mediaTypeDescription }}
          {{ mediaDetailsDescription }}
        </v-list-item-subtitle>
        <v-list-item-subtitle>{{ media.url }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ media.mediaData.path }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action
        style="align-self: center"
        v-if="!isCheckedInternal && !hideActions"
      >
        <v-list-item-subtitle>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="gray text-subtitle-2"
                >updated {{ media.updatedAt | moment('from', 'now') }}
                <v-icon class="gray text-subtitle-2"
                  >mdi-information-outline</v-icon
                ></span
              >
            </template>
            <p>
              Created:
              {{ media.createdAt | moment('dddd, MMMM Do YYYY, h:mm:ss a')
              }}<br />
              Last updated:
              {{ media.updatedAt | moment('dddd, MMMM Do YYYY, h:mm:ss a') }}
            </p>
            <p></p>
          </v-tooltip>
        </v-list-item-subtitle>
        <div class="text-xs-right">
          <!-- <v-btn
            icon
            color="orange"
            v-on:click="openAddToGalleryDialog()"
            title="Add to Gallery"
          >
            <v-icon>mdi-image-album</v-icon>
          </v-btn> -->
          <v-icon
            class="mr-1"
            title="Media has no connections"
            v-if="this.mediaPois"
            >mdi-link-off</v-icon
          >
          <v-btn
            icon
            v-on:click="removeMediaItem()"
            color="error"
            title="Delete"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
          <v-btn icon @click.stop="edit" title="Edit">
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-divider v-if="!gridView">&nbsp;</v-divider>

    <!-- GRID VIEW -->
    <v-card
      :color="mediaTypeColor"
      max-width="250"
      min-width="250"
      v-if="gridView"
      @click="$emit('changeChecked', $event)"
      :outlined="isCheckedInternal"
    >
      <v-list-item v-if="!hideTitle">
        <v-list-item-avatar color="grey">
          <v-icon medium>image</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">
            {{ mediaTypeDescription }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="gray text-subtitle-2"
                  >updated {{ media.updatedAt | moment('from', 'now') }}
                  <v-icon class="gray text-subtitle-2"
                    >mdi-information-outline</v-icon
                  ></span
                >
              </template>
              <p>
                Created:
                {{ media.createdAt | moment('dddd, MMMM Do YYYY, h:mm:ss a')
                }}<br />
                Last updated:
                {{ media.updatedAt | moment('dddd, MMMM Do YYYY, h:mm:ss a') }}
              </p>
              <p></p>
            </v-tooltip>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ mediaDetailsDescription }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-img
        :src="mediaData"
        min-height="150"
        max-height="150"
        class="grey darken-4 black--text align-end"
        @error="onImageError"
      >
        <v-card-title class="subtitle-2 font-weight-medium strokeme">
          {{ media.url }}<br />{{ media.mediaData.path }}<br />{{ media.path }}
        </v-card-title>
      </v-img>

      <!--      <v-img :src="bannerImageUrl" class="black&#45;&#45;text align-end" height="200px" @error="onImageError">-->
      <!--        <v-card-title class="subtitle-2 font-weight-medium">-->
      <!--          {{ media.url }}<br />{{ media.mediaData.path }}-->
      <!--        </v-card-title>-->
      <!--      </v-img>-->

      <v-card-actions v-if="!hideActions">
        <!-- <v-btn
          icon
          color="orange"
          v-on:click="openAddToGalleryDialog()"
          title="Add to Gallery"
        >
          <v-icon>mdi-image-album</v-icon>
        </v-btn> -->
        <v-icon title="Media has no connections" v-if="this.mediaPois"
          >mdi-link-off</v-icon
        >
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.stop="removeMediaItem()"
          color="error"
          title="Delete"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn icon @click.stop="edit" title="Edit">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions style="height: 50px" v-else></v-card-actions>

      <v-fade-transition>
        <v-overlay
          v-if="isCheckedInternal"
          absolute
          color="white"
          opacity="0.6"
        >
        </v-overlay>
      </v-fade-transition>
    </v-card>

    <!--    <add-to-gallery-dialog-->
    <!--      v-if="showAddToGalleryDialog"-->
    <!--      :showDialog="showAddToGalleryDialog"-->
    <!--      @cancel="closeAddToGalleryDialog"-->
    <!--      @done="closeAddToGalleryDialog"-->
    <!--    ></add-to-gallery-dialog>-->
  </div>
</template>

<script>
import Enums from '../../helpers/Enums'

export default {
  components: {},
  props: {
    media: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    hideActions: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    mediaAssetType: {
      type: Number,
      required: false,
      default: Enums.MediaAssetType.image_path
    },
    showCheckbox: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    checked: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },
  watch: {
    async media(newValue) {
      if (this.mediaAssetType === Enums.MediaAssetType.image_path) {
        this.mediaData = await this.getMediaData(newValue)
      } else if (this.mediaAssetType === Enums.MediaAssetType.image_url) {
        this.mediaData = this.media.url
      }
    }
  },
  created: async function() {
    this.getMediaContent(this.$props.media)
    if (this.mediaAssetType === Enums.MediaAssetType.image_path) {
      this.mediaData = await this.getMediaData(this.media)
    } else if (this.mediaAssetType === Enums.MediaAssetType.image_url) {
      this.mediaData = this.media.url
    }
    let res = await this.$store.dispatch(
      'MediaManagerStore/getMediaPois',
      this.media.id
    )
    if (res.data.length) this.mediaPois = false
    else this.mediaPois = true
  },
  computed: {
    showAddToGalleryDialog: {
      get: function() {
        return this.showDialog
      },
      set: function(newValue) {
        this.showDialog = newValue
      }
    },
    isTitleImage: {
      get: function() {
        let retVal = false
        if (this.media.hasOwnProperty('ProjectContent')) {
          retVal =
            this.media.ProjectContent.properties &&
            this.media.ProjectContent.properties.order &&
            this.media.ProjectContent.properties.order === 1
          if (retVal === null) retVal = false
        } else {
          retVal =
            this.media.PoiContent.properties &&
            this.media.PoiContent.properties.order &&
            this.media.PoiContent.properties.order === 1
          if (retVal === null) retVal = false
        }
        return retVal
      }
    },
    mediaTypeDescription: {
      get: function() {
        switch (this.media.mediaTypeId) {
          case Enums.MediaType.project_title_image: {
            return `${this.isTitleImage ? 'Title' : ''} Project Image`
          }
          default: {
            return `${this.isTitleImage ? 'Title' : ''} POI Image`
          }
        }
      }
    },
    mediaTypeColor: {
      get: function() {
        switch (this.media.mediaTypeId) {
          case Enums.MediaType.project_title_image: {
            return 'red lighten-2'
          }
          default: {
            return 'teal darken-4'
          }
        }
      }
    }
  },
  methods: {
    edit() {
      this.$emit('edit', this.media.id)
    },
    getMediaContent: function(media) {
      this.name = media.name
      // if (media.path) {
      //   // local uploaded image
      //   this.bannerImageUrl = '/public/' + media.path
      // } else if (media.url) {
      //   this.bannerImageUrl = media.url
      // } else {
      //   this.bannerImageUrl = './assets/default_file_icon.png'
      // }
      //this.mediaTypesEnum = Enums.MediaType

      //this.mediaTypeDescription =
      this.mediaDetailsDescription = Enums.lang[media.langId].name
      this.descriptionText = media.name

      if (media.mediaData && media.mediaData.path) {
        this.mediaFileDescription =
          media.url + ' [' + media.mediaData.path + ']'
      }
    },
    removeMediaItem: function() {
      this.$emit('deleted', this.media.id)
    },
    openAddToGalleryDialog: async function() {
      await this.$store.dispatch(
        'MediaStore/setSelectedMediaItem',
        this.media.id
      )
      this.$emit('AddToGallery')
    },
    onImageError() {
      console.log('firing onImageError')
      //this.$refs.img.src = `https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg`;
    },
    async getMediaData(media) {
      let retVal = require('../../assets/default_file_icon.png')
      if (media.url !== '') {
        return media.url
      }
      let resp = await this.$store.dispatch('MediaStore/getFile', media)
      if (resp) {
        let mimeType = resp.headers['content-type'].toLowerCase()
        let imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
        retVal = 'data:' + mimeType + ';base64,' + imgBase64
      }
      return retVal

      // if (media.path !== '') {
      //   const resp = await ds
      //     .apiClientThinkHome({
      //       method: 'get',
      //       url: `/media/${media.id}/image`,
      //       responseType: 'arraybuffer'
      //     })
      //     .catch(e => {})
      //
      //   if (resp) {
      //     var mimeType = resp.headers['content-type'].toLowerCase()
      //     var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
      //     retVal = 'data:' + mimeType + ';base64,' + imgBase64
      //   }
      // } else if (media.url !== '') {
      //   retVal = media.url
      // }
      // return retVal
    }
  },
  data: function() {
    return {
      mediaPois: false,
      isChecked: false,
      name: '',
      bannerImageUrl: './assets/default_file_icon.png',
      descriptionText: '',
      mediaDetailsDescription: '',
      mediaFileDescription: '',
      showDialog: false,
      //mediaTypeColor: 'teal darken-4',
      mediaData: '',
      isCheckedInternal: this.checked
    }
  },
  beforeCreate() {
    this.isChecked = this.isCheckedInternal
  }
}
</script>

<style scoped>
.wrapper {
  border-radius: 6px;
  overflow: hidden;
}
.text-xs-right {
  white-space: nowrap;
}
.strokeme {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}
</style>
